import orderManagement from './orderManagement/index.vue'
import refundManagement from './refundManagement/index.vue'
export default {
  orderManagement,
  refundManagement
}
